export default __webpack_public_path__ + "static/media/feature_2.cc301295.png";